import axios from 'axios'

export default {
  ge: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('/slim/', '/gridr/'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  sg: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('/slim/', '/gridr/').replace('https://capico', 'https://sg.capico').replace('https://titan', 'https://sgtitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  get: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('/slim/', '/gridr/').replace('https://capico', 'https://get.capico').replace('https://titan', 'https://gettitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
